/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Mesh_CountInputs */



/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} Wifi mesh" |
* | "other" | "{count} Wifi mesh" |
*
* @param {Mesh_CountInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const mesh_count = /** @type {((inputs: Mesh_CountInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesh_CountInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		const countPlural = registry.plural("en", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} Wifi mesh`);
		if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} Wifi mesh`);
		return /** @type {LocalizedString} */ ("mesh_count");
	}
	{
		const countPlural = registry.plural("fr", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count}  Wifi mesh`);
		if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} x Wifi mesh`);
		return /** @type {LocalizedString} */ ("mesh_count");
	}
});